<div class="field-group">
  <label for="select-tag" *ngIf="TG_label">{{ TG_label }}</label>
  <div class="container">
    <img src="../../../../assets/svgs/{{TG_icon}}.svg" alt="Usuário" *ngIf="TG_icon">
    <ul class="select-choices" [ngClass]="{'is_icon': TG_icon }">
      <li class="elements" *ngFor="let item of TG_list; let i = index">
        <span>{{ item }}</span>
        <a class="action" [id]="item" (click)="tgRemove(i)">
          <img src="../../../../assets/svgs/icon_close_tag.svg" alt="Fechar">
        </a>
      </li>
      <li class="select-search-field" [ngClass]="{'full-line': !TG_list.length}">
        <input class="input-search" id="select-tag"
          [ngClass]="{'shake': shake }"
          type="text" autocomplete="off" autocapitalize="off"
          spellcheck="false" id="select-tag"
          [(ngModel)]="innerValue"
          (input)="tgValidator(innerValue)"
          (keydown)="tgEnter($event)"
          (click)="tgSet()">
      </li>
    </ul>
  </div>
</div>